module.exports = __webpack_public_path__ + "media/fr_ca_s4_Symone.fc5446ab.oga";